import React from "react";
import VerificationInput from "react-verification-input";

interface InputCodeProps {
    length: number;
    onCompleteCode?: Function;
    startFocus?: boolean;
}

export const InputCode = ({ length, onCompleteCode, startFocus }: InputCodeProps) => {
    return (
        <VerificationInput autoFocus={ startFocus } validChars="0-9"
                           inputProps={{ className: "text-transparent border-none", inputMode: "numeric", autoComplete: "one-time-code" }}
                           length={ length }
                           classNames={{
                               container: "h-[56px]",
                               character: "text-base font-medium flex max-w-[56px] max-h-[56px] items-center justify-center bg-light-gray rounded-[14px] outline-none",
                               characterSelected: "text-gray",
                               characterInactive: "text-gray",
                               characterFilled: "text-black"
                           }}
                           placeholder="0"
                           onComplete={ (value: string) => onCompleteCode ? onCompleteCode(value) : {} }
        />
    )
}